// Team data
export const teamMembers = [
  {
    id: 1,
    image: require("../../../assets/Ing. Carlos Rodolfo Guardia. Director. Esp en Ing. Ambiental y en H&S.png"),
    name: "Ing. Carlos R. Guardia",
    position: "Fundador y Director general",
    title: "Ingeniero en vías de comunicación",
  },
  {
    id: 2,
    image: require("../../../assets/Alejandro Benítez. Asesor. Téc. en Gestión Ambiental.jpeg"),
    name: "Lic. Alejandro Benítez",
    position: "Asesor Técnico",
    title: "Licenciado en Gestión Ambiental",
  },
  {
    id: 4,
    image: require("../../../assets/Ing. José Martín Glavas. Asesor. Ing. Químico.png"),
    name: "Ing. José Martín Glavas",
    position: "Asesor Técnico",
    title: "Ingeniero Químico",
  },
  {
    id: 7,
    image: require("../../../assets/Sebastián Patricio Welch. médico.jpeg"),
    name: "Dr. Sebastián Patricio Welsh",
    position: "Asesor Técnico",
    title: "Médico",
  },
  {
    id: 8,
    image: require("../../../assets/jorgesolis.webp"),
    name: "Dr. Jorge Solís Carnicer",
    position: "Asesor Técnico",
    title: "Médico Veterinario",
  },
  {
    id: 9,
    image: require("../../../assets/Ing. Hidráulica María Elina Serrano[2493].jpeg"),
    name: "Ing. María Elina Serrano",
    position: "Asesora Técnica",
    title: "Ingeniera Hidráulica",
  },
];

// Swiper images
export const swiperImages = [
  require("../../../assets/swiper1.png"),
  require("../../../assets/swiper2.png"),
  require("../../../assets/swiper3.png"),
  require("../../../assets/swiper4.png"),
  require("../../../assets/swiper5.png"),
  require("../../../assets/swiper6.png"),
  require("../../../assets/swiper7.png"),
  require("../../../assets/swiper8.png"),
  require("../../../assets/swiper9.png"),
  require("../../../assets/swiper10.png"),
];

// Icons
export const icons = {
  labor: require("../../../assets/icons8-maletín-50.png"),
  title: require("../../../assets/icons8-certification-64.png"),
};
